/**
 * Utilities for porting GLSL code to ts. Uses arrays of numbers in place of GLSL vector types.
 * @module
 */

export function fract(x: number): number {
  return x - Math.floor(x);
}

export function mixVec(a: number[], b: number[], t: number): number[] {
  const result = new Array(a.length);
  for (let i = 0; i < a.length; ++i) {
    result[i] = a[i] * (1 - t) + b[i] * t;
  }
  return result;
}

export function hash21(p: number): number[] {
  let px = fract(p * 0.1031);
  let py = fract(p * 0.103);
  let pz = fract(p * 0.0973);
  const dot = px * (py + 33.33) + py * (pz + 33.33) + pz * (px + 33.33);
  px += dot;
  py += dot;
  pz += dot;
  return [fract((px + py) * pz), fract((px + pz) * py)];
}

export function hash32(x: number, y: number): number[] {
  let px = fract(x * 0.1031);
  let py = fract(y * 0.103);
  let pz = fract(x * 0.0973);
  const dot = px * (py + 33.33) + py * (px + 33.33) + pz * (pz + 33.33);
  px += dot;
  py += dot;
  pz += dot;
  return [fract((px + py) * pz), fract((px + pz) * py), fract((py + pz) * px)];
}
